// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	OverrideIcon: 'override-icon',
	HelpArticlesLink: 'help-articles-link',
	VideoTutorialsLink: 'video-tutorials-link',
	BookTrainingLink: 'book-training-link',
	DocTrainingLink: 'doc-training-link',
	ChatLink: 'chat-link',
} as const;
